import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import Messaging from "bundles/common/components/Messaging/Messaging";
import consumer from "../../channels/consumer";
import CandidateContextSidebar from "./MessagesContent/CandidateContextSidebar";

const recruiterEndpoints = {
  index: "/recruiter/conversations",
  search: "/recruiter/conversations/search",
  show: (id) => `/recruiter/conversations/${id}`,
  message: (id) => `/recruiter/conversations/${id}/messages`,
  read: (id) => `/recruiter/conversations/${id}/read`,
  block_status: (id) => `/recruiter/conversations/${id}/block_status`,
  archive_status: (id) => `/recruiter/conversations/${id}/archive_status`,
};

const peerOf = (item) => {
  const candidate = item?.candidate || {};
  return {
    name: candidate.full_name,
    avatar: candidate.profile_picture_url,
    subtitle: candidate.job_title,
  };
};

const MessagesContent = ({ onUnreadCountChange }) => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const recruiterId = useSelector((state) => state.current_recruiter?.id);

  const goToCvTheque = () => {
    const params = new URLSearchParams(location.search || "");
    params.set("tab", "cv_theque");
    params.delete("conversation");
    navigate(`${location.pathname}?${params.toString()}`);
  };

  const emptyState = (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 10, gap: 1.5 }}>
      <Typography variant="h5" sx={{ color: theme.palette.text.main }}>
        <FormattedMessage id="recruiter.messaging.empty_title" />
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        sx={{ color: theme.palette.text.main, maxWidth: "480px" }}
      >
        <FormattedMessage id="recruiter.messaging.empty_subtitle" />
      </Typography>
      <Button variant="rounded" color="primaryContained" onClick={goToCvTheque} sx={{ mt: 2, px: 4, fontFamily: "Segoe UI Semibold, system-ui, sans-serif" }}>
        <FormattedMessage id="recruiter.messaging.empty_cta" />
      </Button>
    </Box>
  );

  const config = {
    selfType: "Recruiter",
    endpoints: recruiterEndpoints,
    consumer,
    actorChannel: "RecruiterChannel",
    actorId: recruiterId,
    peerOf,
    renderSidebar: (detail, { onClose, inline }) => (
      <CandidateContextSidebar detail={detail} onClose={onClose} inline={inline} />
    ),
    emptyState,
    extraParams: { tab: "messages" },
    scrollIntoViewOnLoad: true,
  };

  return <Messaging config={config} onUnreadCountChange={onUnreadCountChange} />;
};

export default MessagesContent;
